import React from "react";
import { Icon } from "antd";
import { useLocation } from "react-router-dom";

const PageTitle = props => {
  const { mobile } = props;
  let location = useLocation();

  let title = "";
  let icon = "";
  switch (true) {
    case location.pathname === "/" || location.pathname === "/equipment":
      title = "Equipment Finder";
      icon = "profile";
      break;
    case location.pathname === "/about":
      title = "About";
      icon = "";
      break;
    case location.pathname.startsWith("/equipment"):
      title = "Equipment Details";
      icon = "profile";
      break;
    default: {
      title = "";
    }
  }

  return (
    <div className="PageTitle">
      <h2>
        {icon && mobile && (
          <Icon type={icon} style={{ color: "white", paddingRight: "10px" }} />
        )}
        {title}
      </h2>
    </div>
  );
};

export default PageTitle;
